module.exports = __webpack_public_path__ + "static/img/satisfaction-img.12c6dbb5.jpg";